<style></style>
<template>
  <div class="as-modal" :class="{ 'full-width': fullWidth }" v-if="show">
    <div class="modal-container">
      <div class="modal-head">
        <h3>Редактирование страницы</h3>
        <div class="actions-block">
          <ul>
            <li>
              <a href="#" @click.prevent="fullView()" class="as-zoom"
                ><font-awesome-icon class="as-icon" :icon="['fas', 'compress']"
              /></a>
            </li>
            <li><a href="#" @click.prevent="close()" class="as-close">x</a></li>
          </ul>
        </div>
      </div>
      <form @submit.prevent="editPage()" method="POST" action="#">
        <div class="modal-body">
          <div class="form-group">
            <label>Название (title, h1)</label>
            <input type="text" class="form-control" name="name" />
          </div>
          <div class="form-group">
            <label>Название (title, h1)</label>
            <input type="text" class="form-control" name="name" />
          </div>
          <div class="form-group as-editors">
            <label>Описание</label>
            <ckeditor
              id="asEditor"
              class="form-control"
              :editor="ck.editor"
              v-model="ck.editorData"
              :config="ck.editorConfig"
            ></ckeditor>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-link as-close"
            @click.prevent="close()"
          >
            Закрыть
          </button>
          <button type="submit" class="btn btn-success">Сохранить</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      form: [],
      show: false,
      fullWidth: false,
      ck: {
        editor: ClassicEditor,
        editorData: "<p>Описание страницы.</p>",
        editorConfig: {}
      }
    };
  },
  methods: {
    editPage() {},
    close() {
      this.show = false;
      document.body.classList.remove("modal-open");
    },
    fullView() {
      this.fullWidth = !this.fullWidth;
    }
  }
};
</script>
